import { render, staticRenderFns } from "./LightCourseTeaser.vue?vue&type=template&id=436e7d2d&scoped=true&"
import script from "./LightCourseTeaser.vue?vue&type=script&lang=js&"
export * from "./LightCourseTeaser.vue?vue&type=script&lang=js&"
import style0 from "./LightCourseTeaser.vue?vue&type=style&index=0&id=436e7d2d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e7d2d",
  null
  
)

export default component.exports